<div class="container">
  <div class="main-div">
    <div class="center-pane">
      <div class="form-div">

        <div class="header">
          <div class="logo">
            <img alt="email-confirmation" src="assets/envelop-notification.svg"/>
          </div>
          <h2 i18n="@@merchantEmailConfirmationPasswordTitle">Your email is on its way</h2>
          <p i18n="@@merchantEmailConfirmationPasswordSubtitle">Please check your email. You should receive an email with
            a link to reset your password. Once you click it, you will be redirected back to the password reset process.
          </p>
        </div>

        <div *ngIf="serverError !== null"
             class="alert alert-danger form-alert">{{ serverError }}</div>
        <primary-button
          (onClick)="onLoginClicked()"
          [title]="backToLoginLabel">
        </primary-button>

      </div>
    </div>
  </div>
</div>
